import { render, staticRenderFns } from "./ModalRelatorioInventarios.vue?vue&type=template&id=6c12860d&scoped=true"
import script from "./ModalRelatorioInventarios.vue?vue&type=script&lang=js"
export * from "./ModalRelatorioInventarios.vue?vue&type=script&lang=js"
import style0 from "./ModalRelatorioInventarios.vue?vue&type=style&index=0&id=6c12860d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12860d",
  null
  
)

export default component.exports